import { connect } from 'react-redux'
import requestChangeCardName from '../sagas/requestChangeCardName'
import requestFollowCard from '../sagas/requestFollowCard'
import Breadcrumb from './Breadcrumb'
import breadcrumbSelector from './breadcrumbSelector'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  breadcrumbSelector,
  {
    requestChangeCardName,
    requestFollowCard,
  }
)(Breadcrumb))
